import axiosClient from "@/shared/lib/axios/axios.ts";
import { AxiosResponse } from "axios";
import { ApiResponse } from "@/shared/types/api.ts";
import { API_ROUTES } from "@/machines/api/config.ts";
import { formatDateTime } from "@/shared/utils/date/format-datetime.ts";
import { Gps } from "@/machines/types/gps.ts";


export interface IGetGpsInput {
  device_mxid: string;
  start_time: Date;
  end_time: Date;
  max_points: number
}

export const getGps = async (params: IGetGpsInput): Promise<ApiResponse<Gps[]>> => {
  return axiosClient.get<IGetGpsInput, AxiosResponse<ApiResponse<Gps[]>>>(API_ROUTES.GPS, {
    params: {
      device_mxid: params.device_mxid,
      start_time: formatDateTime(params.start_time, "start"),
      end_time: formatDateTime(params.end_time, "end"),
      max_points: params.max_points
    }
  }).then((res) => res.data);
}